<template>
  <div class="w-table" :class="{ 'w-table_moving': dragState.dragging }">
    <template v-if="showTableHeader">
      <div class="chart-header">
        <div class="module-name" v-if="showModuleName">{{ moduleName }}</div>
        <div class="sub-title" v-if="showSubTitle">{{ subTitle }}</div>
      </div>
      <chart-filter-conditions
        :tableConditions="tableConditions"
        :tableHeader="tableHeader"
        @search="search"
      />
    </template>
    <el-table
      v-if="tableData.length"
      v-loading="isloading && !isType"
      :data="tableData"
      :border="option.border"
      :height="option.height"
      :max-height="option.maxHeight"
      :style="{ width: parseInt(option.width) + 'px' }"
      :cell-class-name="cellClassName"
      :header-cell-class-name="headerCellClassName"
      :default-sort="{ prop: 'num', order: 'descending' }"
      ref="hmtable"
    >
      <slot name="fixed"></slot>
      <el-table-column
        v-show="tableHeader.length"
        v-for="(col, index) in tableHeader"
        :key="index"
        :prop="col.columnName"
        :label="col.labelName"
        :type="col.type"
        :header-align="col.headerAlign"
        :column-key="index.toString()"
        :render-header="renderHeader"
        sortable
      >
        <!--  -->
        <!-- :render-header="renderHeader" -->
        <template slot-scope="scope" slot="header">
          <div
            class="thead-cell"
            @mousedown="handleMouseDown(scope.row, col)"
            @mousemove="handleMouseMove(scope.row, col)"
          >
            <span> {{ col.labelName }}</span>
            <span class="virtual"></span>
            <span
              class="hmicon icon-guanbi1 pointer delete-tab"
              @click="del(scope.row, col)"
            ></span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="chart-img-wrapper" v-if="!tableData.length && !isType">
      <img
        src="https://imgcdn.hemiao100.com/decoration/ps3391152084090c82-799b-4bcd-9b51-0bab71a9aa6c.png"
        alt=""
      />
    </div>
    <!-- </transition> -->
  </div>
</template>

<script>
import chartFilterConditions from "@/components/charts/chartFilterConditions";
export default {
  props: {
    employeeId: {
      type: String,
      default: ""
    },
    isType: {
      type: String,
      default: ""
    },
    configId: {
      type: String,
      default: ""
    },
    reportName: {
      type: String,
      default: ""
    },
    data: {
      default: function() {
        return [];
      },
      type: Array
    },
    header: {
      default: function() {
        return [];
      },
      type: Array
    },
    option: {
      default: function() {
        return {
          height: 400
        };
      },
      type: Object
    },
    disableDeleteBtn: {
      type: Boolean,
      default: false
    },
    tableConditions: {
      type: Array,
      default: () => []
    },
    showTableHeader: {
      type: Boolean,
      default: false
    },
    moduleName: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    showModuleName: {
      type: Boolean,
      default: true
    },
    showSubTitle: {
      type: Boolean,
      default: true
    }
  },
  components: {
    chartFilterConditions
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      isloading: false,
      falg: false,
      seach: "",
      tableHeader: this.header,
      dragState: {
        start: -9, // 起始元素的 index
        end: -9, // 移动鼠标时所覆盖的元素 index
        dragging: false, // 是否正在拖动
        direction: undefined // 拖动方向
      },
      hmtable: this.$refs.hmtable,
      transitionShow: true,
      tableData: [],
      keep: []
    };
  },
  watch: {
    header(val) {
      if (this.tableHeader.length !== val.length) {
        this.tableHeader = val;
        this.transitionShowTiem();
      }
      this.hmtable = this.$refs.hmtable;
      if (val) {
        // console.log(this.isType);
        if (this.keep.findIndex(v => v.moduleName === this.moduleName) < 0) {
          this.keep.push({
            moduleName: this.moduleName,
            tableData: []
          });
          this.queryAnalyzeList();
        } else {
          this.tableData = this.keep.filter(
            v => v.moduleName === this.moduleName
          )[0].tableData;

          this.$forceUpdate();
        }
      }
    },
    data(val) {
      if (this.isType !== "phone") {
        if (val) {
          val.forEach(v => {
            for (let key in v) {
              this.tableHeader.forEach(o => {
                if (o.columnName === key && o.associatedDictCode !== "") {
                  v[key] = this.translation(o.associatedDictCode, v[key]);
                }
              });
            }
          });
          this.tableData = val;
        }
      }
    },
    isType(val) {
      if (val === "phone") {
        this.search();
      }
    }
  },
  created() {},

  mounted() {
    this.transitionShow = false;
    if (this.isType === "phone") {
      this.search();
    }
  },
  methods: {
    transitionShowTiem() {
      this.transitionShow = false;
      // setTimeout(() => {
      //   this.tableHeader = val;
      // }, 3000);
      setTimeout(() => {
        this.transitionShow = true;
      }, 800);
    },
    getTable() {
      return this.$refs.hmtable;
    },
    translation(code, columnName) {
      if (columnName) {
        if (this.$sysAllDict[code].find(o => o.value === columnName)) {
          return this.$sysAllDict[code].find(o => o.value === columnName).text;
        } else {
          return "";
        }
      } else {
        return "";
      }
    },
    headerCellClassName({ columnIndex }) {
      let active =
        columnIndex - 1 === this.dragState.end
          ? `darg_active_${this.dragState.direction}`
          : "";
      let start = columnIndex - 1 === this.dragState.start ? `darg_start` : "";
      return `${active} ${start}`;
    },
    cellClassName({ columnIndex }) {
      return columnIndex - 1 === this.dragState.start ? `darg_start` : "";
    },
    renderHeader(createElement, { column, $index }) {
      return createElement(
        "div",
        {
          class: ["thead-cell"],
          on: {
            mousedown: $event => {
              this.handleMouseDown($event, column);
            },
            mousemove: $event => {
              this.handleMouseMove($event, column);
            }
            // click: $event => {
            //   this.del($event, column);
            // }
          }
        },
        [
          // 添加 <a> 用于显示表头 label
          createElement("a", column.label), // 添加一个空标签用于显示拖动动画
          createElement("span", {
            class: ["virtual"]
          })
          // createElement("a", {
          //   class: ["hmicon icon-guanbi1 pointer delete-tab"],
          //   on: {
          //     click: $event => {
          //       this.del($event, column);
          //     }
          //   }
          // }),
          // createElement("el-input", {
          //   on: {
          //     input: value => {
          //       column.filterPlacement = value;
          //       this.query(column);
          //     }
          //   },
          //   style: {
          //     width: "200px",
          //     position: "absolute",
          //     top: "35px",
          //     left: "0"
          //   },
          //   props: {
          //     value: column.filterPlacement,
          //     size: "mini"
          //   },
          //   attrs: {
          //     // placeholder: "请输入" + column.label
          //   }
          // })
        ]
      );
    },
    query(column) {
      if (this.data.length) {
        this.filterFunc(column.property, column.filterPlacement);

        // this.falg = false;
        // this.tableHeader.forEach(v => {
        //   if (v.filterPlacement !== "") {
        //     this.falg = true;
        //   }
        // });
      }
    },
    filterFunc(property, val) {
      this.tableData = this.data.filter(v => {
        return v[property].indexOf(val) > -1;
      });
      // this.$forceUpdate();

      // if (this.falg) {
      // } else {
      //   this.tableData = JSON.parse(JSON.stringify(this.data));
      // }
    },
    del(e, column) {
      this.transitionShowTiem();
      setTimeout(() => {
        this.tableHeader.splice(+column.columnKey, 1);
        this.$emit("delHeader", this.tableHeader);
      }, 500);
    },
    // 按下鼠标开始拖动
    handleMouseDown(e, column) {
      this.dragState.dragging = true;
      this.dragState.start = parseInt(column.columnKey);
      // 给拖动时的虚拟容器添加宽高
      let table = document.getElementsByClassName("w-table")[0];
      let virtual = document.getElementsByClassName("virtual");
      for (let item of virtual) {
        item.style.height = table.clientHeight - 1 + "px";
        item.style.width = item.parentElement.parentElement.clientWidth + "px";
      }
      document.addEventListener("mouseup", this.handleMouseUp);
    },

    // 鼠标放开结束拖动
    handleMouseUp() {
      this.dragColumn(this.dragState);
      // 初始化拖动状态
      this.dragState = {
        start: -9,
        end: -9,
        dragging: false,
        direction: undefined
      };
      document.removeEventListener("mouseup", this.handleMouseUp);
    },
    initData(data) {
      this.tableData = data;
      this.tableHeader = this.tableHeader;
    },

    // 拖动中
    handleMouseMove(e, column) {
      if (this.dragState.dragging) {
        let index = parseInt(column.columnKey); // 记录起始列
        if (index - this.dragState.start !== 0) {
          this.dragState.direction =
            index - this.dragState.start < 0 ? "left" : "right"; // 判断拖动方向
          this.dragState.end = parseInt(column.columnKey);
        } else {
          this.dragState.direction = undefined;
        }
      } else {
        return false;
      }
    },

    // 拖动易位
    dragColumn({ start, end, direction }) {
      let tempData = [];
      let left = direction === "left";
      let min = left ? end : start - 1;
      let max = left ? start + 1 : end;
      for (let i = 0; i < this.tableHeader.length; i++) {
        if (i === end) {
          tempData.push(this.tableHeader[start]);
        } else if (i > min && i < max) {
          tempData.push(this.tableHeader[left ? i - 1 : i + 1]);
        } else {
          tempData.push(this.tableHeader[i]);
        }
      }

      this.tableHeader = tempData;
      this.$emit("dragHeader", this.tableHeader);
    },
    search() {
      if (this.tableHeader.length) {
        this.queryAnalyzeList();
      } else {
        this.$message({
          message: "请添加表头",
          type: "warning"
        });
      }
    },
    async queryAnalyzeList() {
      let whereColumns = [];
      let selectColumns = [];
      let groupColumns = [];
      let falg = false;
      this.tableConditions.forEach(v => {
        if (v.isRequiredWhere === "yes") {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                falg = true;
              } else {
                whereColumns.push(v);
              }
            }
          }
        } else {
          if (v.columnType === "datetime") {
            if (v.queryMode === "range") {
              if (v.applyDate === null || v.applyDate.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          } else {
            if (v.isMultiple) {
              if (v.queryListValue.length === 0) {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            } else {
              if (v.queryValue === "") {
                // falg = false;
              } else {
                whereColumns.push(v);
              }
            }
          }
        }
      });
      if (falg) {
        this.$message({
          message: "请填写完必填项",
          type: "warning"
        });
      } else {
        let show = false;
        const allConditions = this.tableHeader.concat(this.tableConditions);
        allConditions.forEach(v => {
          if (v.isAggregateColumn === "yes") {
            show = true;
          }
        });
        if (show) {
          allConditions.forEach(v => {
            if (v.isAggregateColumn !== "yes") {
              groupColumns.push(v);
            }
          });
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
        } else {
          selectColumns = JSON.parse(JSON.stringify(this.tableHeader));
          // this.col.forEach(v => {
          //   if (v.isSelectColumn === "yes") {
          //     selectColumns.push(v);
          //   }
          //   if (v.isGroupColumn === "yes") {
          //     groupColumns.push(v);
          //   }
          // });
        }

        // if (this.tableHeader === "table") {
        //   selectColumns = JSON.parse(JSON.stringify(this.col));
        //   groupColumns = [];
        // } else {
        //   groupColumns = JSON.parse(JSON.stringify(this.col));
        //   selectColumns = JSON.parse(JSON.stringify(this.tableGroup));
        // }

        // let selectColumns = JSON.parse(JSON.stringify(this.col));
        // let groupColumns = JSON.parse(JSON.stringify(this.col));
        whereColumns.forEach(v => {
          if (v.queryMode === "range") {
            if (v.columnType === "datetime") {
              v.queryStartValue = v.applyDate[0];
              v.queryEndValue = v.applyDate[1];
            }
          }
        });
        // this.tableHeader
        // this.tableConditions
        let tableHeader = {
          tableHeader: this.tableHeader,
          AllHeader: this.tableList
        };
        if (!this.tableHeader.length) {
          return;
        }
        let params = {
          id: this.configId || this.$route.query.id,
          whereColumns,
          selectColumns,
          groupColumns,
          tableHeader: JSON.stringify(tableHeader),
          queryCondition: JSON.stringify(this.tableConditions),
          returnDataMode: "sync",
          mode: "dev"
        };
        this.isloading = true;
        if (this.isType === "phone") {
          params.configId = this.configId;
          params.employeeId = this.employeeId;
          const { result, code } = await this.$store.dispatch(
            "addSsrAnalysisQueueByEmployeeId",
            params
          );
          if (code === "0") {
            this.isloading = false;
            let tableDatas = JSON.parse(result.responseResultContent);
            tableDatas = tableDatas.slice(0, 200);
            selectColumns.forEach(v => {
              if (v.associatedDictCode !== "") {
                tableDatas.forEach(k => {
                  k[v.associatedDictCode] = this.translation(
                    v.associatedDictCode,
                    k[v.columnName]
                  );
                });
              }
            });
            this.tableData = tableDatas;
            this.keep.forEach(v => {
              if (v.moduleName === this.moduleName) {
                v.tableData = tableDatas;
              }
            });

            this.$emit("setTableData", tableDatas);
          }
        } else {
          const { result, code } = await this.$store.dispatch(
            "queryAnalyzeList",
            params
          );
          if (code === "0") {
            this.isloading = false;
            let tableDatas = JSON.parse(result.responseResultContent);
            tableDatas = tableDatas.slice(0, 200);
            this.$emit("setTableData", tableDatas);
          }
        }
      }
    }
  },
  translation(code, columnName) {
    if (columnName) {
      if (this.$sysAllDict[code].find(o => o.value === columnName)) {
        return this.$sysAllDict[code].find(o => o.value === columnName).text;
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
};
</script>
<style lang="scss">
.w-table {
  //   border: 1px solid #ebeef5;
  //   border-bottom: none;
  .el-table .darg_start {
    background-color: #f3f3f3;
  }
  .el-table th {
    padding: 0;
    .virtual {
      position: fixed;
      display: block;
      width: 0;
      height: 0;
      margin-left: -10px;
      background: none;
      border: none;
    }
    &.darg_active_left {
      .virtual {
        border-left: 2px dotted #666;
        z-index: 99;
      }
    }
    &.darg_active_right {
      .virtual {
        border-right: 2px dotted #666;
        z-index: 99;
      }
    }
  }
  .thead-cell {
    padding: 0;
    display: inline-flex;
    height: 40px;
    // flex-direction: column;
    // align-items: left;
    cursor: pointer;
    overflow: initial;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
    .delete-tab {
      //   position: absolute;
      //   top: 50%;
      //     left: ;
      //   margin-top: -10px;
      z-index: 999;
      margin-top: 10px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin-left: 10px;
      &.hmicon {
        font-size: 12px;
      }
    }
  }
  &.w-table_moving {
    .el-table th .thead-cell {
      cursor: move !important;
    }
    .el-table__fixed {
      cursor: not-allowed;
    }
  }
  .el-loading-spinner {
    background-image: url("https://imgcdn.hemiao100.com/ThemePictures/reporting.gif"); // 这个是自己想设置的 gif 加载动图
    background-repeat: no-repeat; //设置背景 图 不重复
    height: 100%;
    background-position: center; //设置背景 定位  为居中
    top: 0; //覆盖 element-ui  默认的 50%    因为此处设置了height:100%,所以不设置的话，会只显示一半，因为被top顶下去了
  }
  .el-loading-spinner .circular {
    display: none; //隐藏 之前  element-ui  默认的 loading 动画
  }
}
</style>
<style lang="scss" scoped>
.chart-header {
  background: #fff;
  padding: 15px;
  .module-name {
    font-size: 16px;
    font-weight: bold;
    line-height: 30px;
  }
  .sub-title {
    font-size: 14px;
  }
}
</style>
